import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/renren': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M214 169.1C214 279.5 153 374.5 66.4 416.5 30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5V169.1zM255 504C212.1 504 171.7 493 136.5 473.6 193.7 437.5 239.9 382.9 255 319 270.5 382.9 316.7 437.5 373.8 473.7 338.7 493 298.3 504 255 504zM445.6 416.5C359 374.5 298 279.6 298 169.1V12.5C414.9 32.2 504 133.9 504 256.6 504 317.7 482 373.2 445.6 416.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/renren.js
// module id = 2Hzk
// module chunks = 144